<template>
    <avatar
        :username="app.name"
        :src="app.logo"
        :size="size"
        :customStyle="{ 'background-size': 'contain', 'background-position': 'center' }"/>
</template>

<script>
export default {
    name: 'AppLogo',
    props: {
        app: {
            type: Object,
            required: true
        },
        size: {
            type: Number,
            default: 50
        }
    }
}
</script>
